module.exports = __webpack_public_path__ + "static/media/voice-recorder.82924a1e.svg";